// removed by extract-text-webpack-plugin
module.exports = {"container":"RT2d","placeholder":"_2xmw","image":"_2TJ3","background":"_7O9H","parallax":"_1CWJ"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/LandingPage/SaitsImage/styles.scss
// module id = 424
// module chunks = 0